import CoursePrivateLearningCoachingModuleForm from '@/views/App/Course/PrivateLearningCoachingModule/Form.vue';
import CoursePrivateLearningCoachingModuleList from '@/views/App/Course/PrivateLearningCoachingModule/List.vue';

const routesCoursePrivateLearningCoachingModule = [
    {
        path: 'list',
        name: 'coursePrivateLearningCoachingModuleList',
        component: CoursePrivateLearningCoachingModuleList
    },
    {
        path: 'form/:id?',
        name: 'coursePrivateLearningCoachingModuleForm',
        component: CoursePrivateLearningCoachingModuleForm
    },
];

export default routesCoursePrivateLearningCoachingModule;